export default {
  None: 0, // Chưa tuyển sinh
  OnTime: 1, // Đang tuyển sinh
  NotExpired: 2, // Chưa đến hạn
  Expired: 3, // Quá hạn
}
